(() => {
  'use strict';

  const cfg = window.MVDP_ANALYTICS_CONFIG || {};
  const PREFIX = 'mvdp:';
  const once = new Set();

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().slice(0, 160);
  }

  function safeUrl(value) {
    try {
      return new URL(value, window.location.href);
    } catch (_) {
      return null;
    }
  }

  function baseData(extra) {
    return Object.assign({
      page_path: window.location.pathname,
      page_type: cfg.pageType || '',
      template_name: cfg.templateName || ''
    }, extra || {});
  }

  function publish(name, data, attempt) {
    attempt = attempt || 0;
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(PREFIX + name, baseData(data));
      return;
    }
    if (attempt < 20) {
      window.setTimeout(() => publish(name, data, attempt + 1), 250);
    }
  }

  function publishOnce(key, name, data) {
    if (once.has(key)) return;
    once.add(key);
    publish(name, data);
  }

  function handleClick(event) {
    const link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const text = cleanText(link.textContent);
    const url = safeUrl(href);

    if (
      cfg.productIsArtwork &&
      url &&
      url.origin === window.location.origin &&
      url.pathname === '/pages/studio' &&
      url.searchParams.has('artwork')
    ) {
      publish('artwork_inquiry_click', {
        artwork_title: cfg.productTitle || url.searchParams.get('artwork') || '',
        artwork_handle: cfg.productHandle || '',
        link_text: text || 'INQUIRE'
      });
      return;
    }

    if (href.toLowerCase().startsWith('mailto:marcus@marcusvdepaula.com')) {
      if (cfg.productIsArtwork && (text.toLowerCase().includes('inquire') || href.toLowerCase().includes('artwork%20inquiry'))) {
        publish('artwork_inquiry_click', {
          artwork_title: cfg.productTitle || '',
          artwork_handle: cfg.productHandle || '',
          link_text: text || 'INQUIRE'
        });
      } else if (window.location.pathname.indexOf('/pages/studio') === 0) {
        publish('studio_contact_click', { link_text: text || 'email' });
      } else {
        publish('email_contact_click', { link_text: text || 'email' });
      }
      return;
    }

    if (!url) return;
    const host = url.hostname.replace(/^www\./, '');

    if (host === 'wexlergallery.com' || host.endsWith('.wexlergallery.com')) {
      publish('gallery_outbound_click', {
        link_domain: host,
        link_url: url.href,
        link_text: text
      });
      return;
    }

    if (window.location.pathname.indexOf('/pages/press') === 0 && url.origin !== window.location.origin) {
      publish('press_outbound_click', {
        link_domain: host,
        link_url: url.href,
        link_text: text
      });
      return;
    }

    if (
      window.location.pathname.indexOf('/pages/studio') === 0 &&
      /(schedule|visit|viewing|appointment)/i.test(text)
    ) {
      publish('studio_viewing_click', {
        link_domain: host,
        link_url: url.href,
        link_text: text
      });
    }
  }

  function detectSuccessfulForms() {
    if (document.querySelector('#ContactForm .form-status.form__message:not([role="alert"])')) {
      const params = new URLSearchParams(window.location.search);
      const artwork = params.get('artwork') || '';
      publishOnce('contact_form_success', 'contact_form_success', {
        form_name: 'contact',
        artwork_title: artwork
      });
    }

    if (document.getElementById('ContactFooter-success')) {
      publishOnce('newsletter_signup', 'newsletter_signup', { form_name: 'footer_newsletter' });
    }
  }

  function trackArtworkDepth() {
    if (!cfg.productIsArtwork || !cfg.productHandle) return;

    try {
      const key = 'mvdp_artworks_viewed';
      const existing = JSON.parse(sessionStorage.getItem(key) || '[]');
      const unique = Array.from(new Set(existing.filter(Boolean)));
      const before = unique.length;

      if (!unique.includes(cfg.productHandle)) {
        unique.push(cfg.productHandle);
        sessionStorage.setItem(key, JSON.stringify(unique.slice(-20)));
      }

      if (before === 1 && unique.length === 2) {
        publishOnce('second_artwork_view', 'second_artwork_view', {
          artwork_title: cfg.productTitle || '',
          artwork_handle: cfg.productHandle,
          artwork_count: 2
        });
      }
    } catch (_) {}
  }

  function trackPracticeDepth() {
    try {
      const path = window.location.pathname;
      if (path === '/' || path.indexOf('/search') === 0) return;

      const key = 'mvdp_meaningful_pages';
      const existing = JSON.parse(sessionStorage.getItem(key) || '[]');
      const unique = Array.from(new Set(existing.filter(Boolean)));
      const before = unique.length;

      if (!unique.includes(path)) {
        unique.push(path);
        sessionStorage.setItem(key, JSON.stringify(unique.slice(-30)));
      }

      if (before === 2 && unique.length === 3) {
        publishOnce('practice_depth_3', 'practice_depth_3', {
          unique_page_count: 3,
          current_path: path
        });
      }
    } catch (_) {}
  }

  function trackDeepEngagement() {
    let visibleSeconds = 0;
    let maxScroll = 0;
    let fired = false;

    function scrollRatio() {
      const doc = document.documentElement;
      const max = Math.max(doc.scrollHeight - window.innerHeight, 1);
      return Math.min(1, Math.max(0, window.scrollY / max));
    }

    function maybeFire() {
      maxScroll = Math.max(maxScroll, scrollRatio());
      if (!fired && visibleSeconds >= 60 && maxScroll >= 0.5) {
        fired = true;
        publish('practice_engaged', {
          visible_seconds: visibleSeconds,
          max_scroll_percent: Math.round(maxScroll * 100)
        });
      }
    }

    window.addEventListener('scroll', maybeFire, { passive: true });

    window.setInterval(() => {
      if (document.visibilityState === 'visible') visibleSeconds += 5;
      maybeFire();
    }, 5000);
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('DOMContentLoaded', () => {
    detectSuccessfulForms();
    trackArtworkDepth();
    trackPracticeDepth();
    trackDeepEngagement();
  });
})();